import { CLIPBOARD_FORMAT_TEXT } from '../constants/clipboard'
import { EMPTY_STRING } from '../constants/common'

/**
 * @param {ClipboardEvent} event - Paste event
 *
 * @returns {string}
 */
export function getClipboardText(event) {
  return event.clipboardData?.getData(CLIPBOARD_FORMAT_TEXT) ?? EMPTY_STRING
}

/**
 * @returns {boolean}
 */
export function isClipboardWriteSupported() {
  return (
    typeof navigator !== 'undefined' && Boolean(navigator.clipboard?.writeText)
  )
}
